var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectedIncomes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.3062,
    width: 37,
    height: 30,
    rx: 8,
    fill: "#12B1B4",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 5.06934C11.7332 5.06934 12.125 5.46109 12.125 5.94434V33.9443C12.125 35.3941 13.3003 36.5693 14.75 36.5693H42.75C43.2332 36.5693 43.625 36.9611 43.625 37.4443C43.625 37.9276 43.2332 38.3193 42.75 38.3193H14.75C12.3338 38.3193 10.375 36.3606 10.375 33.9443V5.94434C10.375 5.46109 10.7668 5.06934 11.25 5.06934Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 15.5693C18.7332 15.5693 19.125 15.9611 19.125 16.4443V30.4443C19.125 30.9276 18.7332 31.3193 18.25 31.3193C17.7668 31.3193 17.375 30.9276 17.375 30.4443V16.4443C17.375 15.9611 17.7668 15.5693 18.25 15.5693Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 26.0693C25.7332 26.0693 26.125 26.4611 26.125 26.9443V30.4443C26.125 30.9276 25.7332 31.3193 25.25 31.3193C24.7668 31.3193 24.375 30.9276 24.375 30.4443V26.9443C24.375 26.4611 24.7668 26.0693 25.25 26.0693Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.25 8.56934C32.7332 8.56934 33.125 8.96109 33.125 9.44434V30.4443C33.125 30.9276 32.7332 31.3193 32.25 31.3193C31.7668 31.3193 31.375 30.9276 31.375 30.4443V9.44434C31.375 8.96109 31.7668 8.56934 32.25 8.56934Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.25 19.0693C39.7332 19.0693 40.125 19.4611 40.125 19.9443V30.4443C40.125 30.9276 39.7332 31.3193 39.25 31.3193C38.7668 31.3193 38.375 30.9276 38.375 30.4443V19.9443C38.375 19.4611 38.7668 19.0693 39.25 19.0693Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectedIncomes);
export default __webpack_public_path__ + "static/media/projected-incomes.4f8e95bd0f01ca14505934c967f1c58b.svg";
export { ForwardRef as ReactComponent };